const Utern = () => {
  return (
    <div>
      <p>
        UTERN is University of Toronto’s Student Environmental Resource Network,
        an organization that helps the funding of clubs interested in
        sustainability on campus.
      </p>
      <br />
      <p>
        I redesigned the UTERN logo for their rebrand to go with their new
        website. Since UTERN is a UofT organization, the logo contains three
        overlapping leaves, representing the three campuses of UofT. The
        circular shape and the dynamism of the logo also highlights UTERN’s role
        as a network for environmentalism.
      </p>
    </div>
  );
};

export default Utern;
